export const GALLERY_ITEMS_BATCH_SIZE = 30;
export const GALLERY_ITEM_INDENT = 12;
export const GALLERY_SCROLL_THRESHOLD = 100;
